<!--
  同種藥物用的多重藥盒取藥, 補藥
-->

<template>
  <div>
    <Action 
      v-if="stage === 'confirmAmount'"
      v-on:confirmAmountFinish="confirmAmountFinish"
      :defaultNum="forAction.defaultNum"
      :autoCaculateAmount="false"
      :compType="'Confirm'"
      :defaultPackCount="theDrugStorage.pack_count"
      :deviceId="forAction.deviceId"
      :checkNum="forAction.checkNum" >
      <h5>確認藥盒內數量</h5>
    </Action>
    <Action 
      v-if="stage === 'action'"
      v-on:setActionData="getThisAmount"
      v-on:setTotalSumInstanly="getTotalSumInstanly"
      :defaultNum="forAction.defaultNum"
      :autoCaculateAmount="false"
      :defaultPackCount="0"
      :deviceId="forAction.deviceId"
      :onlyPc="true"
      :inputReadOnly="fetchReadOnly"
      :checkNum="forAction.checkNum" >
      <h5>自此藥盒取藥數量 (pc)</h5>
    </Action>
    <ActionBreak 
      v-if="stage === 'break'"
      v-on:goOn="goOn" 
      :residual="amount - totalAmount" />
    <Loader v-if="stage === 'next'"/>
  </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import Action from '../flowComp/Action';
import ActionBreak from '../flowComp/ActionBreak';
import Loader from '../common/Loader';
import ScanBarcode from '../flowComp/ScanBarcode';

export default {
  name: 'FetchActionWrap',
  props: {
    amount: Number,
    barcodeData: Object,
    medRecordId: String,
    // scheduleId: Number,
    actionProgress: Array,
    startActionType: String,
    reviewer: Object,
  },
  components: {
    Action,
    ActionBreak,
    Loader,
    ScanBarcode,
  },
  computed: {
    currentDrugInDevice() {
      return this.$store.state.drugInDevice.currentDrugInDevice;
    },
    drugStorageWithSameDrug() {
      return this.$store.state.drugInDevice.DrugStorageWithSameDrug;
    },
    instance() {
      return this.$store.state.instance;
    },
    fetchReadOnly() {
      if (this.barcodeData !== undefined && Object.keys(this.barcodeData).length > 0) return true;
      return false;
    },
  },
  data() {
    return {
      stage: '',
      totalAmount: 0, // already fetched
      drugStorageInQueue: [], // device queue with same drug
      drugStorageList: [],
      theDrugStorage: {},
      theDrugStorageIndex: 0,
      actionData: [],
      forAction: {
        defaultNum: 0,
        checkNum: 0,
        deviceId: 0,
      },
      residual: 0,
      getEmitTimes: 0,
      progressIndex: 0,
      scheduleId: undefined,
      oriNextDrugStorageId: undefined,
    };
  },
  destroyed() {
    console.log('一般取藥 ActionWrap destroyed');
    this.totalAmount = 0;
    this.drugStorageInQueue = {};
    this.drugStorageInQueueId = [];
    this.theDrugStorage = {};
    this.theDrugStorageIndex = 0;
    this.forAction = {
      defaultNum: 0,
      checkNum: 0,
      deviceId: 0,
    };
    this.getEmitTimes = 0;
    this.$store.commit('SET_APP_CANCEL_STATUS', true);
  },
  created() {
    this.$store.commit('SET_APP_CANCEL_STATUS', false);
    // console.log(this.forAction);
    // prepare for the first Action child. remove the first one(user selected one), then set the remains into state.
    this.drugStorageInQueue = this.drugStorageWithSameDrug;
    console.log(this.drugStorageWithSameDrug);

    // this.$store.commit('SET_CONFIRM_STAGE', 'confirmAmount');
    this.moveCurrentStorageToHead(this.currentDrugInDevice.id);
    this.residual = this.amount;
    this.theDrugStorage = this.drugStorageList[this.theDrugStorageIndex];
    this.$store.commit('SET_CURRENT_DRUG_IN_DEVICE', this.theDrugStorage.id);
    // prepare forAction data
    if (this.actionProgress[0] === 'confirmAmount') {
      this.forAction = {
        defaultNum: this.theDrugStorage.stock,
        checkNum: this.theDrugStorage.max_stock,
        deviceId: this.theDrugStorage.device.id,
      };
      this.$store.commit('SET_CURRENT_STEP', 'confirmAmount');
    }
    if (this.actionProgress[0] === 'action') {
      this.forAction = {
        defaultNum: this.amount,
        checkNum: this.theDrugStorage.stock,
        deviceId: this.theDrugStorage.device.id,
      };
      this.$store.commit('SET_CURRENT_STEP', 'action');
    }
    this.stage = this.actionProgress[0]; // well, it seems that the new refaction could not fit actionWrap flow.
  },
  methods: {
    async confirmAmountFinish() {
      console.log('drugstorage', this.theDrugStorage);
      await this.$store.dispatch('updateCurrentDrugInDevice', this.theDrugStorage.id);
      // notice: the stock of drugStorage might change here.
      this.theDrugStorage = this.$store.state.drugInDevice.allDrugInDevice[this.theDrugStorage.id];
      //
      this.forAction = {
        defaultNum: this.amount - this.totalAmount, // the resident number for child.
        checkNum: this.theDrugStorage.stock > this.residual ? this.residual : this.theDrugStorage.stock,
        deviceId: this.theDrugStorage.device.id,
      };

      this.stage = 'next';
      // 如果確認之後為0 就跳過該藥盒
      if (this.currentDrugInDevice.stock === 0) {
        if (this.theDrugStorageIndex + 1 < this.drugStorageList.length) {
          this.theDrugStorageIndex += 1;
          this.residual = this.amount - this.totalAmount;
          this.theDrugStorage = this.drugStorageList[this.theDrugStorageIndex];
          this.forAction = {
            defaultNum: this.amount - this.totalAmount, // the resident number for child.
            checkNum: this.theDrugStorage.stock > this.residual ? this.residual : this.theDrugStorage.stock,
            deviceId: this.theDrugStorage.device.id,
          };
          // set next DrugStorage
          const nextDrugStorage = this.drugStorageList[this.theDrugStorageIndex];
          this.$store.commit('SET_NEXT_DEVICE', nextDrugStorage.device.id);
          this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', nextDrugStorage.id);
          this.stage = 'break';
        } else {
          if ((this.amount - this.totalAmount) > 0) {
            this.$store.commit('SET_MESSAGE', {
              type: 'warn',
              context: `尚有${this.amount - this.totalAmount}未拿，請自行至外部藥盒拿取。`,
              keepOnTop: true,
            });
          }
          //20190426 add
          console.log('store.state.drugInDevice.currentDrugInDevice:',this.$store.state.drugInDevice.currentDrugInDevice);
          console.log('store.state.drugInDevice.nextDrugInDevice:',this.$store.state.drugInDevice.nextDrugInDevice); 
          if (this.$store.state.drugInDevice.nextDrugInDevice){  
            console.log('store.state.drugInDevice.currentDrugInDevice.id:',this.$store.state.drugInDevice.currentDrugInDevice.id);
            console.log('store.state.drugInDevice.nextDrugInDevice.id:',this.$store.state.drugInDevice.nextDrugInDevice.id);
            //console.log(this.$store.state.drugInDevice);
            this.resetNextDrugInDevice();
            //沒有下個藥要取
            if (this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex >= (this.$store.state.drugInDevice.sortedSelectedDrugInDevice.length) - 1) {
              console.log('remove:case a');
              this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
              this.$store.commit('REMOVE_NEXT_DEVICE');
            }
            else //還有下個藥可取
            {
              if(this.$store.state.drugInDevice.currentDrugInDevice.id === this.$store.state.drugInDevice.nextDrugInDevice.id)
              {
                //去撈下個排序的藥的id並設為next device
                const tmpNextDrugStorage = this.$store.state.drugInDevice.sortedSelectedDrugInDevice[this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex+1];
                console.log(tmpNextDrugStorage);
                if(tmpNextDrugStorage)
                {
                  console.log('tmpNextDrugStorage.device.id:',tmpNextDrugStorage.device.id);
                  this.$store.commit('SET_NEXT_DEVICE', tmpNextDrugStorage.device.id);
                  this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', tmpNextDrugStorage.id);
                }
                else
                {
                  console.log('remove:case b');
                  this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                  this.$store.commit('REMOVE_NEXT_DEVICE');    
                }
              }
            }
          }
          else
          {
            console.log('remove:case c');
            this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
            this.$store.commit('REMOVE_NEXT_DEVICE');  
          }
          setTimeout(() => { this.$emit('setActionData'); }, 1000);
        }
      } else {
        // notice: the stock of drugStorage might change here.
        this.theDrugStorage = this.$store.state.drugInDevice.allDrugInDevice[this.theDrugStorage.id];
        //
        this.forAction = {
          defaultNum: this.amount - this.totalAmount, // the resident number for child.
          checkNum: this.theDrugStorage.stock > this.residual ? this.residual : this.theDrugStorage.stock,
          deviceId: this.theDrugStorage.device.id,
        };
        setTimeout(() => {
          this.stage = 'action';
          this.$store.commit('SET_CURRENT_STEP', 'action');
        }, 200);
        this.getTotalSumInstanly(this.amount - this.totalAmount);
      }
    },
    moveCurrentStorageToHead(drugStorageId) {
      const current = this.drugStorageInQueue[drugStorageId];
      delete this.drugStorageInQueue[drugStorageId];
      this.drugStorageList = Object.values(this.drugStorageInQueue);
      // 領藥條件： 最接近過期 > 散裝量最多
      //this.drugStorageList = _.orderBy(this.drugStorageList, [(o) => { return new Date(o.expired_date); }, (o) => { return o.stock - (o.medication.pack_content * o.pack_count); }], ['asc', 'desc']);
      //20190524
      // 領藥條件： 最接近過期 > 散裝量最小 
      this.drugStorageList = _.orderBy(this.drugStorageList, [(o) => { return new Date(o.expired_date); }, (o) => { return o.stock - (o.medication.pack_content * o.pack_count); }], ['asc', 'asc']);
      this.drugStorageList.unshift(current); // insert the current one to the head.
      // this.$store.commit('SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY', this.drugStorageList);
    },
    saveData(data) {
      console.log(data);
      const currentDrugStorage = this.theDrugStorage;
      if (this.currentDrugInDevice.stock - data.num < 0) {
        throw new Error('the saving stock should not be miuns');
      } else {
        const remainPc = currentDrugStorage.stock - (currentDrugStorage.medication.pack_content * currentDrugStorage.pack_count);
        let remainPackCount = currentDrugStorage.pack_count;
        if (remainPackCount !== 0 && currentDrugStorage.medication.pack_content !== 0) {
          remainPackCount = currentDrugStorage.pack_count - Math.ceil((data.num - remainPc) / currentDrugStorage.medication.pack_content);
        }
        console.log(remainPackCount);
        if (this.$store.state.schedule.currentSchedule) {
          this.scheduleId = this.$store.state.schedule.currentSchedule.id;
        }

        let medRecrodNumber = null;
        if (this.medRecordId !== undefined) {
          medRecrodNumber = this.medRecordId;
        } else if (this.barcodeData !== undefined) {
          medRecrodNumber = this.barcodeData.medRecordId;
        } else if (this.$store.state.schedule.currentSchedule !== undefined) {
          medRecrodNumber = this.$store.state.schedule.currentSchedule.patient.med_record_number;
        } else {
          medRecrodNumber = null;
        }
        // console.log(this.medRecordId, this.barcodeData, this.$store.state.schedule.currentSchedule, medRecrodNumber);

        // becareful that other components used this comp.
        let eventType = 'FETCH';
        if (this.startActionType === 'FETCH_TRANSFER') {
          eventType = 'FETCH_TRANSFER';
        }

        const sentData = {
          id: currentDrugStorage.id,
          device: data.device,
          stock: currentDrugStorage.stock - data.num, // only update here.
          max_stock: currentDrugStorage.max_stock,
          expired_date: currentDrugStorage.expired_date,
          patch_number: currentDrugStorage.patch_number,
          medication: currentDrugStorage.medication.id,
          med_record_no: medRecrodNumber,
          number1: -(data.num),
          number2: this.scheduleId,
          pack_count: remainPackCount,
          type: eventType,
          review_employee: this.reviewer === undefined ? undefined : this.reviewer.id,
        };

        if (data.emptyCount > 0) {
          sentData.empty_count = currentDrugStorage.empty_count + data.emptyCount;
        }

        this.stage = 'next';
        return this.instance.put(`/api/drug-storage/${sentData.id}/`, sentData)
        .then((drugStorageActionRes) => {
          // update the amount after saving
          this.$store.dispatch('getTotalDrugAmountInstanly', currentDrugStorage.medication.id);

          // record Return Empty if neeed
          if (data.emptyCount > 0) {
            this.$store.dispatch('recordAction', { eventType: 'RETURN_EMPTY', number1: data.emptyCount })
            .then(async (eventActionRes) => {
              const event = {
                id: drugStorageActionRes.data,
                checked: true,
                related_events: [eventActionRes.data],
              };
              await this.instance.patch(`/api/event/${event.id}/`, event);
            });
          }

          console.log('set drug storage.');
        })
        .catch((res) => {
          console.log('fetch drug error');
        });
      }
    },
    goOn() {
      let defaultNumCalc = 0;
      let checkNumCalc = 0;
      if (this.actionProgress[0] === 'confirmAmount') {
        defaultNumCalc = this.theDrugStorage.stock;
        checkNumCalc = this.theDrugStorage.max_stock;
      }
      if (this.actionProgress[0] === 'action') {
        defaultNumCalc = this.residual;
        checkNumCalc = this.theDrugStorage.stock > this.residual ? this.residual : this.theDrugStorage.stock;
      }

      this.forAction = {
        defaultNum: defaultNumCalc, // the resident number for child.
        checkNum: checkNumCalc,
        deviceId: this.theDrugStorage.device.id,
      };
      this.$store.commit('SET_CURRENT_DRUG_IN_DEVICE', this.theDrugStorage.id);
      this.stage = this.actionProgress[0]; // TODO: remove it here.
      this.getEmitTimes = 0;
      this.resetNextDrugInDevice();
    },
    resetNextDrugInDevice() {
      // reset drugStorage id if it has been changed previous.
      console.log('resetNextDrugInDevice');
      if (this.$store.state.drugInDevice.nextDrugInDevice) {
          // save the drugStorage id temporaliy.
          this.oriNextDrugStorageId = this.$store.state.drugInDevice.nextDrugInDevice.id;
      }
      console.log('this.oriNextDrugStorageId:',this.oriNextDrugStorageId);
      if (this.oriNextDrugStorageId) {
        this.$store.commit('SET_NEXT_DEVICE', this.$store.state.drugInDevice.allDrugInDevice[this.oriNextDrugStorageId].device.id);
        this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', this.oriNextDrugStorageId);
      }
    },
    getTotalSumInstanly(val) {
      console.log('get total amount instanly', val, this.residual);
      console.log('theDrugStorageIndex:', this.theDrugStorageIndex);
      console.log('drugStorageList.length:', this.drugStorageList.length);
      // check fetch amount from current drugStorage is enough or not
      if (val < this.residual) {
        //20190429 modified
        //if (this.theDrugStorageIndex + 1 <= this.drugStorageList.length) {
        if (this.theDrugStorageIndex + 1 < this.drugStorageList.length) {
          const nextDrugStorage = this.drugStorageList[this.theDrugStorageIndex + 1];
          if (this.$store.state.drugInDevice.nextDrugInDevice) {
            // save the drugStorage id temporaliy.
            this.oriNextDrugStorageId = this.$store.state.drugInDevice.nextDrugInDevice.id;
          }
          console.log('nextDrugStorage.device.id:', nextDrugStorage.device.id);
          this.$store.commit('SET_NEXT_DEVICE', nextDrugStorage.device.id);
          this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', nextDrugStorage.id);
        } else {
          console.log('no enough amount for fetching.');
        }
      } else {
        this.resetNextDrugInDevice();
        console.log('sortedSelectedDrugInDeviceIndex:',this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex);
        console.log('sortedSelectedDrugInDevice.length:',this.$store.state.drugInDevice.sortedSelectedDrugInDevice.length);
        console.log('store.state.drugInDevice.currentDrugInDevice.id:',this.$store.state.drugInDevice.currentDrugInDevice.id);
        if(this.$store.state.drugInDevice.nextDrugInDevice){
          console.log('store.state.drugInDevice.nextDrugInDevice.id:',this.$store.state.drugInDevice.nextDrugInDevice.id);
        }
        if (this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex >= (this.$store.state.drugInDevice.sortedSelectedDrugInDevice.length) - 1) {
          console.log('remove:case aa');
          this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
          this.$store.commit('REMOVE_NEXT_DEVICE');
        }
        else //還有下個藥可取
        {
          if(this.$store.state.drugInDevice.nextDrugInDevice)
          {
            if(this.$store.state.drugInDevice.currentDrugInDevice.id === this.$store.state.drugInDevice.nextDrugInDevice.id)
            {
              //去撈下個排序的藥的id並設為next device
              const tmp2NextDrugStorage = this.$store.state.drugInDevice.sortedSelectedDrugInDevice[this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex+1];
              console.log(tmp2NextDrugStorage);
              if(tmp2NextDrugStorage)
              {
                console.log('tmp2NextDrugStorage.device.id:',tmp2NextDrugStorage.device.id);
                this.$store.commit('SET_NEXT_DEVICE', tmp2NextDrugStorage.device.id);
                this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', tmp2NextDrugStorage.id);
              }
              else
              {
                console.log('remove:case bb');
                this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                this.$store.commit('REMOVE_NEXT_DEVICE');    
              }
            }
          }
        }
      }
    },
    async getThisAmount(data) {
      this.getEmitTimes += 1; // prevent over emitting
      if (this.getEmitTimes === 1) {
        // this.stage = 'next';
        // data: device, num
        this.totalAmount += data.num;
        await this.saveData(data);

        // record Return Empty if neeed
        // if (data.emptyCount > 0) {
        //   await this.$store.dispatch('recordAction', { eventType: 'RETURN_EMPTY', number1: data.emptyCount });
        // }

        // increment the index
        this.theDrugStorageIndex += 1;
        // await this.$store.dispatch('getTotalDrugAmountInstanly', this.$store.state.drug.selectedDrugID);
        if (this.totalAmount < this.amount) {
          if (this.theDrugStorageIndex < this.drugStorageList.length) {
            this.residual = this.amount - this.totalAmount;
            this.theDrugStorage = this.drugStorageList[this.theDrugStorageIndex];
            this.stage = 'break';
          } else {
            this.$store.commit('SET_MESSAGE', {
              type: 'warn',
              context: `尚有${this.amount - this.totalAmount}未拿，請自行至外部藥盒拿取。`,
              keepOnTop: true,
            });
            // TODO: here is not emit yet. thus the action will stop at here.
            // make fetch drug in outside drug box is recorded.
            this.getEmitTimes = 0;
            setTimeout(() => { this.$emit('setActionData'); }, 1000);
          }
        } else {
          console.log('finished');
          // this.resetNextDrugInDevice();
          this.$emit('setActionData');
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// ActionWrap.vue?46d627a6